export const blockIconsContentLink = (
	<span className='material-symbols-outlined'>link</span>
);
